module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pb4"
  }, [_c('top-nav', [_c('div', {
    staticClass: "tl"
  }, [_c('default-button', {
    nativeOn: {
      "click": function($event) {
        _vm.goToOrderList($event)
      }
    }
  }, [_vm._v("← Back")])], 1)]), _vm._v(" "), (!_vm.order && _vm.loading) ? _c('span', [_vm._v("Loading...")]) : _vm._e(), _vm._v(" "), (_vm.order) ? _c('div', {
    staticClass: "order"
  }, [_c('content-card', [_c('h2', [_vm._v("Order details")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('form-element', [_c('label', [_vm._v("Id :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order._id),
      expression: "order._id"
    }],
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.order._id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.order, "_id", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('form-element', {
    attrs: {
      "three": ""
    }
  }, [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedState),
      expression: "selectedState"
    }],
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedState = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.orderStatus['COMPLETED']
    }
  }, [_vm._v("COMPLETED")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.orderStatus['SHIPPED']
    }
  }, [_vm._v("SHIPPED")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.orderStatus['RECEIVED']
    }
  }, [_vm._v("RECEIVED")])]), _vm._v(" "), (_vm.loading) ? _c('span', {
    staticClass: "db pl1"
  }, [_vm._v("Saving...")]) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Order Content")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "w-25 ba tc ma1 ml0 pa1 overflow-hidden",
    staticStyle: {
      "white-space": "nowrap",
      "text-overflow": "ellipsis"
    }
  }, [_vm._v("Product")]), _vm._v(" "), _c('div', {
    staticClass: "w-25 ba tc ma1 pa1"
  }, [_vm._v("Price")]), _vm._v(" "), _c('div', {
    staticClass: "w-25 ba tc ma1 pa1"
  }, [_vm._v("Quantity")]), _vm._v(" "), _c('div', {
    staticClass: "w-25 ba tc ma1 mr0 pa1"
  }, [_vm._v("Total")])]), _vm._v(" "), _vm._l((_vm.order.content), function(line, i) {
    return _c('div', {
      key: i,
      staticClass: "flex"
    }, [_c('div', {
      staticClass: "w-25 ba ma1 ml0 pa1 overflow-hidden",
      staticStyle: {
        "white-space": "nowrap",
        "text-overflow": "ellipsis"
      }
    }, [_vm._v(_vm._s(line.product ? line.product.name : '?'))]), _vm._v(" "), _c('div', {
      staticClass: "w-25 ba ma1 pa1"
    }, [_vm._v(_vm._s(line.finalPrice))]), _vm._v(" "), _c('div', {
      staticClass: "w-25 ba ma1 pa1"
    }, [_vm._v(_vm._s(line.quantity))]), _vm._v(" "), _c('div', {
      staticClass: "w-25 ba ma1 mr0 pa1"
    }, [_vm._v(_vm._s(line.quantity * line.finalPrice))])])
  })], 2), _vm._v(" "), (_vm.address) ? _c('div', [_c('hr'), _vm._v(" "), _c('h3', [_vm._v("Address")]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('div', {}, [_c('span', {
    staticClass: "db pa1 address-element"
  }, [_vm._v("Email :")]), _vm._v(" "), _c('span', {
    staticClass: "db pa1 address-element"
  }, [_vm._v("Address 1 : ")]), _vm._v(" "), _c('span', {
    staticClass: "db pa1 address-element"
  }, [_vm._v("Address 2 : ")]), _vm._v(" "), _c('span', {
    staticClass: "db pa1 address-element"
  }, [_vm._v("State : ")]), _vm._v(" "), _c('span', {
    staticClass: "db pa1 address-element"
  }, [_vm._v("Zipcode :")]), _vm._v(" "), _c('span', {
    staticClass: "db pa1 address-element"
  }, [_vm._v("Country :")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex-grow": "1"
    }
  }, [_c('span', {
    staticClass: "db pa1 b address-element"
  }, [_c('span', [_vm._v(_vm._s(_vm.address.email) + " ")])]), _vm._v(" "), _c('span', {
    staticClass: "db pa1 b address-element"
  }, [_c('span', [_vm._v(_vm._s(_vm.address.line1) + " ")])]), _vm._v(" "), _c('span', {
    staticClass: "db pa1 b address-element"
  }, [_c('span', [_vm._v(_vm._s(_vm.address.line2) + " ")])]), _vm._v(" "), _c('span', {
    staticClass: "db pa1 b address-element"
  }, [_c('span', [_vm._v(_vm._s(_vm.address.state) + " ")])]), _vm._v(" "), _c('span', {
    staticClass: "db pa1 b address-element"
  }, [_c('span', [_vm._v(_vm._s(_vm.address.zipcode) + " ")])]), _vm._v(" "), _c('span', {
    staticClass: "db pa1 b address-element"
  }, [_c('span', [_vm._v(_vm._s(_vm.address.country) + " ")])])])])]) : _vm._e(), _vm._v(" "), (_vm.payment) ? _c('div', [_c('hr'), _vm._v(" "), _c('h3', [_vm._v("Payment")]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('div', [_c('span', {
    staticClass: "db pa1 payment-element"
  }, [_vm._v("Status: ")]), _vm._v(" "), _c('span', {
    staticClass: "db pa1 payment-element"
  }, [_vm._v("Captured:")]), _vm._v(" "), _c('span', {
    staticClass: "db pa1 payment-element"
  }, [_vm._v("Amount: ")])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "db pa1 b payment-element"
  }, [_c('span', [_vm._v(_vm._s(_vm.payment.status))]), _vm._v(" ")]), _vm._v(" "), _c('span', {
    staticClass: "db pa1 b payment-element"
  }, [_c('span', [_vm._v(_vm._s(_vm.payment.captured))]), _vm._v(" ")]), _vm._v(" "), _c('span', {
    staticClass: "db pa1 b payment-element"
  }, [_c('span', [_vm._v(_vm._s(_vm.payment.amount / 100) + " " + _vm._s(_vm.payment.currency))]), _vm._v(" ")])])])]) : _vm._e()], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34751756","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./admin/src/components/OrderDetails.vue
// module id = 249
// module chunks = 0